import {
  methods as dictionary,
  typedMethods as dictionaryMethods,
} from "./types/dictionary";
import { methods as users, typedMethods as usersMethods } from "./types/users";
import {
  methods as localization,
  typedMethods as localizationMethods,
} from "./types/localization";
import {
  methods as aiHelper,
  typedMethods as aiHelperMethods,
} from "./types/aiHelper";

export const placeholder = true;

export const methods = {
  dictionary,
  users,
  localization,
  aiHelper,
};

type TypesMethods = {
  dictionary: typeof dictionaryMethods;
  users: typeof usersMethods;
  localization: typeof localizationMethods;
  aiHelper: typeof aiHelperMethods;
};
export const typesMethods: TypesMethods = methods;
